import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';

export interface IHistogramDataModel extends IRestModel {
    values: Array<number>;
    registerID: number;
    histogramID: number;
    histogramType: string;
}

export class HistogramDataModel extends BaseModel implements IHistogramDataModel, IRestModel {
    public readonly isIRestModel = true;

    public error: string = null;
    public statusCode: number = null;

    public values: Array<number> = null;
    public registerID: number = null;
    public histogramID: number = null;
    public histogramType: string = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-HistogramDataModel');

        this.values = restModel.Values;
    }

    public toRestApiModel(): any {
        return {
            ...RestModelUtility.toJson(this),
        };
    }
}
